import { useMemo } from 'react';

import { useIsQuestionsOnlyMode, useIsScheduledPostEnabled } from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useScheduledPostSettings: UseMainUIFeatureSettings<'scheduledPost'> = (options) => {
  const scheduledPostOverrides = options?.overrides?.scheduledPost;
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();

  const isScheduledPostEnabled = useIsScheduledPostEnabled();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        ...scheduledPostOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: isScheduledPostEnabled,
      ...scheduledPostOverrides,
    };
  }, [isQuestionsOnlyMode, isScheduledPostEnabled, scheduledPostOverrides]);
};
